import React from "react";
import { connect } from "react-redux";
import { Switch, Redirect } from "react-router-dom";

//Customs
import PrivateRoute from "../PrivateRoute";

//Selectors
import { isLogged } from "../../store/auth/selectors";

//* ROUTES *//
//* DEDUCTIONS ADMIN
import AdministrationRoutes from "./Administration";
import FinancialSquareRoutes from "./FinancialSquare";
import HistoryRoutes from "./History";

const BenefitsRoutes = ({ isLogged }) => {
  return (
    <Switch>
      <PrivateRoute
        path="/deductions/administration"
        component={AdministrationRoutes}
        isAuthenticated={isLogged}
      />
      <PrivateRoute
        path="/deductions/financial-square"
        component={FinancialSquareRoutes}
        isAuthenticated={isLogged}
      />
      <PrivateRoute
        path="/deductions/historical"
        component={HistoryRoutes}
        isAuthenticated={isLogged}
      />
      {/* <Redirect to="/administration/positions" /> */}
      <Redirect to="/" />
    </Switch>
  );
};

const mapStateToProps = (state) => ({
  isLogged: isLogged(state),
});

export default connect(mapStateToProps)(BenefitsRoutes);
